import { render, staticRenderFns } from "./custSalary.vue?vue&type=template&id=0d23f004&scoped=true&"
import script from "./custSalary.vue?vue&type=script&lang=js&"
export * from "./custSalary.vue?vue&type=script&lang=js&"
import style0 from "./custSalary.vue?vue&type=style&index=0&id=0d23f004&prod&lang=scss&scoped=true&"
import style1 from "./custSalary.vue?vue&type=style&index=1&id=0d23f004&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d23f004",
  null
  
)

export default component.exports